// Prevent double-binding (e.g. script enqueued twice / HMR / multiple renders)
if (!window.__osTilePromoBound) {
	window.__osTilePromoBound = true;

	const hasTileOpen = document.querySelector(".tile-promo.tile-open");
	if (!hasTileOpen) {
		document.addEventListener(
			"click",
			(e) => {
				const heading = e.target?.closest?.(".tile-promo__heading");
				if (!heading) return;
	
				const item = heading.closest(".tile-promo__item");
				if (!item) return;
	
	
				document.querySelectorAll(".tile-promo__item.active").forEach((activeItem) => {
					if (activeItem === item) return; // skip the one we toggled	
					activeItem.classList.remove("active");
				});
	
	
				item.classList.toggle("active");
	
				// If duplicate listeners exist, don't let them undo the toggle.
				e.stopImmediatePropagation();
			},
			true // capture so we run before bubbled duplicates
		);
	}

	
}